import { combineReducers } from 'redux'

import dishTypeReducer from './dish-type-reducer'
import dishTypesReducer from './dish-types-reducer'

export default combineReducers({
  dishTypes: dishTypesReducer,
  dishType: dishTypeReducer,
})
